module.exports = __webpack_public_path__ + "img/Samsung_case_study_11.ef01fb5f.jpg";